import React from "react";
import "./main.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0ProviderWithHistory } from "./auth/AuthProviderWithHistory";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
// @ts-ignore
const root = createRoot(container);
const router = createBrowserRouter([
    {
        path: "/*",
        element: (
            <Auth0ProviderWithHistory>
                <App />
            </Auth0ProviderWithHistory>
        )
    }
]);
root.render(<RouterProvider router={router} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
